import { render, staticRenderFns } from "./customerRating.vue?vue&type=template&id=828f51cc&"
import script from "./customerRating.vue?vue&type=script&lang=js&"
export * from "./customerRating.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('828f51cc')) {
      api.createRecord('828f51cc', component.options)
    } else {
      api.reload('828f51cc', component.options)
    }
    module.hot.accept("./customerRating.vue?vue&type=template&id=828f51cc&", function () {
      api.rerender('828f51cc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/Sales/components/CrmSetting/customerRating.vue"
export default component.exports